import { ThemeDefinition } from 'vuetify';

// Slöjd
export const crafts: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#C6684E',
    'on-subject-original': '#FFFFFF',
    subject: '#BD593D',
    'on-subject': '#FFFFFF',
    primary: '#8F432E',
    'on-primary': '#FFFFFF',
    'primary-container': '#ECCEC5',
    'on-primary-container': '#291421',
    secondary: '#6A544E',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#DED5D3',
    'on-secondary-container': '#231C1A',
    surface: '#FCF8F7',
    'on-surface': '#201E1D',
    'on-surface-medium': '#504A49',
    'on-surface-low': '#9E9694',
    outline: '#867C79',
    'outline-variant': '#CFCBC9',
    'inverse-surface': '#422A24',
    'inverse-on-surface': '#F9EFEC',
    'inverse-primary': '#E6BDB2',
    'surface-dim': '#EBCBC2',
    'surface-bright': '#FEFCFB',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#FAF2F0',
    'surface-container': '#F7EBE8',
    'surface-container-high': '#F2DED9',
    'surface-container-highest': '#F0D8D1',
  },
};

export const craftsDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#C6684E',
    'on-subject-original': '#FDF8F7',
    subject: '#DDA697',
    'on-subject': '#2E160F',
    primary: '#EAC7BD',
    'on-primary': '#2E160F',
    'primary-container': '#743625',
    'on-primary-container': '#F9EFEC',
    secondary: '#D8CDCA',
    'on-secondary': '#231C1A',
    'secondary-container': '#584641',
    'on-secondary-container': '#F4F1F0',
    surface: '#181210',
    'on-surface': '#F3F2F2',
    'on-surface-medium': '#CFC9CD',
    'on-surface-low': '#867C79',
    outline: '#867C79',
    'outline-variant': '#6B6361',
    'inverse-surface': '#EDE1DE',
    'inverse-on-surface': '#281915',
    'inverse-primary': '#4D2419',
    'surface-dim': '#15100E',
    'surface-bright': '#46342F',
    'surface-container-lowest': '#120E0C',
    'surface-container-low': '#1F1714',
    'surface-container': '#281D1B',
    'surface-container-high': '#342723',
    'surface-container-highest': '#43322D',
  },
};
